module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-horizon",
    class: [
      'menu-horizon-' + _vm.size,
      _vm.border ? 'menu-horizon-border' : ''
    ]
  }, [_vm._l((_vm.surface), function(item, index) {
    return _c('menus-horizon-item', {
      attrs: {
        "type": item.type || _vm.type,
        "alias": item.alias || '',
        "icon": item.icon,
        "current-icon": item.currentIcon,
        "title": item.title,
        "path": item.path,
        "tip": item.tip,
        "current": _vm.currentSelf == item.alias
      },
      on: {
        "on-click": _vm._handleClick
      }
    })
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-612beefb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus-horizon/menus-horizon.vue
// module id = 256
// module chunks = 36